import {Injectable} from "@angular/core";
import * as URI from "urijs";

@Injectable()
export class MapUrlUtils {

  private locationToUrlObject(location): any {

    let url = {
      path : location.pathname,
      query : null,
      hash : null
    };

    if (location.search.length > 0) {
      url.query = location.search.substring(1);
    }

    if (location.hash.length > 0) {
      url.hash = location.hash.substring(1);
    }

    return url;
  };

  public resolveDataFromUrl(windowLocation) {

    let data: any = {};
    let url: any = this.locationToUrlObject(windowLocation);
    let parameters: any = {};

    if (url.hash && url.hash.length > 0) {

      let parametersString: any = url.hash.split('&');

      for (let item of parametersString) {
        let param: any = item.split('=');
        parameters[param[0]] = param[1];
      }
    }

    //Map geo data: latitude, longitude and zoom
    if (parameters.g) {
      let geo_data: any = parameters.g.split(',');
      data.lat = geo_data[0] ? parseFloat(geo_data[0]) : null;
      data.lng = geo_data[1] ? parseFloat(geo_data[1]): null;
      data.zoom = geo_data[2] ? parseInt(geo_data[2]) : null;
    }

    //Profession codes
    data.firstProfession = parameters.fp ? parameters.fp : null;
    data.secondProfession = parameters.sp ? parameters.sp : null;

    //First profession custom income
    if (parameters.fpi) {
      let income: number = parseFloat(parameters.fpi.replace(/[^0-9.]/g, ''));
      data.firstProfessionIncome = !isNaN(income) ? income : null;
    }

    //Second profession custom income
    if (parameters.spi) {
      let income: number = parseFloat(parameters.spi.replace(/[^0-9.]/g, ''));
      data.secondProfessionIncome = !isNaN(income) ? income : null;
    }

    //Family definition
    if (parameters.hm) {

      let householdMembersData: any = parameters.hm.split(',');
      let householdMembers: any = [];
      let key = 0;

      for (let item of householdMembersData) {

        let age: any = item.match(/[0-9]+/);
        let gender: any = item.match(/[a-zA-Z]/);

        if (age[0] && gender[0]) {
          householdMembers.push({
            id: key + 1,
            age: age[0],
            gender: gender[0]
          });

          key ++;
        }
      }

      data.householdMembers = householdMembers;
    }

    //House rent area
    if (parameters.hra) {
      let area: number = parseInt(parameters.hra.replace(/[^0-9.]/g, ''));
      data.houseRentArea = !isNaN(area) ? area : null;
    }

    //Food plan
    data.foodPlan = parameters.fpl ? parameters.fpl : null;

    //Bedrooms
    if (parameters.br) {
      let bedrooms: any = parameters.br.split(',');
      data.bedroomsMin = Math.min.apply(null, bedrooms);
      data.bedroomsMax = Math.max.apply(null, bedrooms);
    }

    //Selected tract code
    data.selectedTract = parameters.st ? parameters.st : null;

    data.profileId = parameters.p ? parameters.p : null;

    return data;
  }

  public resolveUrlFromData(baseUrl: any, data: any) {

    let url = new URI(baseUrl);

    let parameters: any = {};
    let parametersString: string = '';

    if (data.state && data.city) {
      url = url.path(url.directory() + '/' + data.state.toLowerCase() + '/' + data.city.toLowerCase() + '/');
    }

    try {

      if (data.lat && data.lng && data.zoom) {
        parameters.g = data.lat.toFixed(7) + ',' + data.lng.toFixed(7) + ',' + data.zoom;
      }

      if (data.profileId) {
        parameters.p = data.profileId;
      } else {

        if (data.firstProfession) {
          parameters.fp = data.firstProfession;
        }

        if (data.secondProfession) {
          parameters.sp = data.secondProfession;
        }

        if (data.firstProfessionIncome) {
          parameters.fpi = data.firstProfessionIncome;
        }

        if (data.secondProfessionIncome) {
          parameters.spi = data.secondProfessionIncome;
        }

        if (data.householdMembers) {

          let counter: number = 0;
          parameters.hm = '';

          for (var key in data.householdMembers) {

            var member = data.householdMembers[key];

            if (counter > 0) {
              parameters.hm += ',';
            }

            parameters.hm += member.age + member.gender;
            counter ++;
          }
        }

        if (data.houseRentArea) {
          parameters.hra = data.houseRentArea;
        }

        if (data.foodPlan) {
          parameters.fpl = data.foodPlan.code;
        }

        if (data.bedroomsMin && data.bedroomsMax) {
          let bedrooms: any = [];
          for (var i = data.bedroomsMin; i <= data.bedroomsMax; i++) {
            bedrooms.push(i);
          }
          parameters.br = bedrooms.join(',');
        }
      }

      if (data.selectedTract) {
        parameters.st = data.selectedTract;
      }

      let counter = 0;

      for (var key in parameters) {

        if (counter > 0) {
          parametersString += '&';
        }

        parametersString += key + '=' + parameters[key];
        counter++;
      }

      url = url.hash(parametersString)

    } catch (error) {
      console.log(error);
    }

    return url;
  }

  public supportHistoryApi() {
    return window.history && window.history.replaceState;
  }
}



// WEBPACK FOOTER //
// ./common/utils/mapurlutils.ts